import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
} from "@mui/material";

import { useAuth } from "../../../context/AuthContext";

const Navbar = () => {
  const { currentUser, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar position="static" color="secondary">
      <Container>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <RouterLink
              to="/"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img src="images/logo.png" width={190} />
            </RouterLink>
          </Typography>
          {currentUser && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {(currentUser?.role === "admin" || currentUser.role === "ta") && (
                <Button color="inherit" component={RouterLink} to="/admin">
                  어드민 페이지
                </Button>
              )}
              <Button color="inherit" onClick={handleLogout}>
                로그아웃
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
